import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { apiOrganization } from "src/services/Api/Organization/apiOrganization";
import { ArchivesApi } from "src/services/Api/Organization/types";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { LoadingContainer } from "go-core/components/Loading";
import { ArchivePreview } from "../../components/ArchivePreview/ArchivePreview";

interface MatchParams {
	archiveId: string;
}

export const OrganizationSettingsArchivesPreviewPage = () => {
	const [archiveInfo, setArchiveInfo] = useState<ArchivesApi | undefined>(undefined);
	const { archiveId } = useParams<MatchParams>();
	const { addFlash } = useFlash();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const { t } = useTranslation();

	const getArchiveInfo = async () => {
		try {
			const archiveData = await apiOrganization.getArchiveInfo(Number(archiveId));
			setArchiveInfo(archiveData);
			const archiveInfoFormattedDate = FormatDate(archiveData.date);
			handleChangeTabTitle(`${archiveInfoFormattedDate} | ${t("modules.archives.header.title")}`);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	useEffect(() => {
		getArchiveInfo();
	}, []);

	if (!archiveInfo) return <LoadingContainer />;

	return (
		<div className="content">
			<ArchivePreview archiveInfo={archiveInfo} setArchiveInfo={setArchiveInfo} />
		</div>
	);
};

// t("enums.common.status.IN_PROGRESS")
// t("enums.common.status.CLOSING")
